import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';

export default function LimitTags({ placeholder, setGoals, goals = [], errors, setValue }) {
  const [inputValue, setInputValue] = React.useState('');

  const handleChange = (event, value) => {
    setValue('goals', value);
    setGoals([...value]);
  };

  const addCurrentGoal = () => {
    const trimmed = inputValue.trim();
    if (!trimmed) return;
    const newGoals = [...(goals || []), trimmed];
    setValue('goals', newGoals);
    setGoals(newGoals);
    setInputValue('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addCurrentGoal();
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <Autocomplete
          multiple
          id="tags-filled"
          value={goals || []}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
          options={[]}
          onChange={handleChange}
          freeSolo
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Box component="span" key={index}>
                <Chip label={option} {...getTagProps({ index })} />
                {index < value.length - 1 && ','}
              </Box>
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              onKeyDown={handleKeyDown}
              sx={{
                flex: 1,
                minWidth: 200,
                '& .MuiButtonBase-root': { background: 'white !important' },
              }}
              variant="filled"
              label={placeholder}
            />
          )}
          error={(errors && !!errors?.goals).toString()}
          sx={{ flex: 1, minWidth: 200 }}
        />
        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={addCurrentGoal}
          startIcon={<AddIcon />}
          sx={{ mt: 0.5, flexShrink: 0 }}
        >
          Add goal
        </Button>
      </Box>
      <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary' }}>
        Type each goal and click &quot;Add goal&quot; or press Enter to add it to the list.
      </Typography>
      {errors && !!errors?.goals && (
        <Typography variant="caption" sx={{ fontSize: '15px', position: 'absolute', color: 'error.main' }}>
          {errors?.goals?.message}
        </Typography>
      )}
    </div>
  );
}
